import styled from "styled-components";

export const FilterCard = styled.div`
	background-color: #fff;
	border: 1px solid #eeefff;
	border-radius: 8px;
	width: 100%;
`;

export const FilterTitle = styled.h2`
	font-size: 16px;
	font-weight: bold;
	color: #000 !important;
	padding: 12px 16px;
	border-bottom: 1px solid #eeefff;
`;

export const FilterBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding-inline: 16px;
	margin: 16px 0 12px 0;
`;

export const FilterSubtitle = styled.h3`
	font-size: 16px;
	font-weight: bold;
	color: #000 !important;
`;

export const FieldsRow = styled.div`
	display: grid;
	grid-template-columns: repeat(6, minmax(144px, 1fr));
	gap: 16px;

	@media (max-width: 1400px) {
		grid-template-columns: repeat(3, minmax(180px, 1fr));
	}

	@media (max-width: 800px) {
		grid-template-columns: 1fr;
	}
`;

export const ActionsRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;
	margin-top: 24px;
`;

export const ClearButton = styled.button`
	background: transparent;
	border: 1px solid #504c9a;
	padding: 8px 32px;
	color: #504c9a;
	font-size: 16px;
	line-height: 23px;
	font-weight: bold;
	border-radius: 8px;
	cursor: pointer;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.65;
	}
`;

export const ApplyButton = styled.button`
	background: #504c9a;
	border: 1px solid #504c9a;
	padding: 8px 32px;
	color: #fff;
	font-size: 16px;
	line-height: 23px;
	font-weight: bold;
	border-radius: 8px;
	cursor: pointer;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.65;
	}
`;
